import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { ZHH_SESSION_LIMIT_ACTION_TYPE } from "./zhh-session-limit.action";
import { ZhhSessionLimitState } from "./zhh-session-limit.model";

const INITIAL_STATE: ZhhSessionLimitState = {};

export function zhhSessionLimitReducer(state = INITIAL_STATE, action: ActionWithPayload): ZhhSessionLimitState {
	switch (action.type) {
		case ZHH_SESSION_LIMIT_ACTION_TYPE.getSuccess: {
			return updateState(state, {
				sessionLimit: action.payload,
			});
		}
		case ZHH_SESSION_LIMIT_ACTION_TYPE.reset:
			return INITIAL_STATE;
		default:
			return state;
	}
}
